/**
 * Tiny localStorage cache with versioning + soft TTL.
 * - Instantly returns cached value if present (SWR-style).
 * - Silently revalidates from network and updates cache.
 */
const VERSION = "v1";

export function cacheGet(key) {
  try {
    const raw = localStorage.getItem(`cache:${VERSION}:${key}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.data ?? null;
  } catch { return null; }
}

export function cacheSet(key, data) {
  try {
    localStorage.setItem(`cache:${VERSION}:${key}`,
      JSON.stringify({ data, savedAt: Date.now() }));
  } catch (e) {
    // Storage full — evict oldest cached entries then retry once
    try {
      const entries = [];
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (k && k.startsWith(`cache:${VERSION}:`)) {
          try {
            const v = JSON.parse(localStorage.getItem(k) || "{}");
            entries.push([k, v.savedAt || 0]);
          } catch {}
        }
      }
      entries.sort((a, b) => a[1] - b[1]);
      entries.slice(0, Math.ceil(entries.length / 3)).forEach(([k]) => localStorage.removeItem(k));
      localStorage.setItem(`cache:${VERSION}:${key}`,
        JSON.stringify({ data, savedAt: Date.now() }));
    } catch {}
  }
}

export function cacheDel(key) {
  try { localStorage.removeItem(`cache:${VERSION}:${key}`); } catch {}
}
